if(!customElements.get('article-grid')) {
  class ArticlesGrid extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.getAttribute('id');

      this.pageSize = Number(this.getAttribute('page-size'));
      this.pageCurrent = Number(this.getAttribute('page-current'));
      this.pageTotal = Number(this.getAttribute('page-total'));
      this.pageNext = this.getAttribute('page-next');

      this.elGrid = this.querySelector('[data-grid]');
      this.elPaginate = this.querySelector('[data-paginate]');

      this.elPaginate && this.elPaginate.addEventListener('click', this.paginateArticles.bind(this));
    }

    paginateArticles() {
      if(this.pageCurrent < this.pageTotal) {
        this.loadArticles(this.pageNext)
          .then(data => {
            this.pageCurrent = data.currentPage;
            this.pageNext = data.nextPage;

            data.articles.forEach(el => {
              this.elGrid.appendChild(el);
            })

            this.elGrid.setAttribute('aria-busy', false);
            this.pageCurrent == this.pageTotal && this.elPaginate.classList.add('hidden');
            window.initLazyLoad();
          })
          .catch(err => {
            console.log(err);
            this.elGrid.setAttribute('aria-busy', false);
          })
      }
    }

    async loadArticles(url) {
      const response = await fetch(url);
      const data = await response.text();

      const html = document.createElement("html");
      html.innerHTML = data;

      const elSection = html.querySelector(`#${this.sectionId}`);
      const elGrid = elSection.querySelector('[data-grid]');
      const elArticles = [...elGrid.querySelectorAll('[data-article]')];

      return {
        currentPage: elSection.getAttribute('page-current'),
        nextPage: elSection.getAttribute('page-next'),
        articles: elArticles,
      };
    }
  }

  customElements.define('articles-grid', ArticlesGrid);
}